export default __webpack_public_path__ + "static/media/reportDesign.68faa803.png";